/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Edytowalne pole kroku planu, którego dotyczy wpis STEP_UPDATED.
 * @export
 * @enum {string}
 */

export const DevelopmentPathStepFieldDto = {
    Milestone: 'MILESTONE',
    StartDate: 'START_DATE',
    Deadline: 'DEADLINE',
    Actions: 'ACTIONS'
} as const;

export type DevelopmentPathStepFieldDto = typeof DevelopmentPathStepFieldDto[keyof typeof DevelopmentPathStepFieldDto];



